import React, { useState, useEffect } from 'react';

const ClientEditModal = ({ clientData, sellers = [], onSave, onClose }) => {
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        notes: '',
        sellerId: '',
        sellerName: '',
        contacts: [{ name: '', email: '', phone: '', isPrimary: true }]
    });

    const isEditMode = clientData && clientData.id;

    useEffect(() => {
        if (isEditMode) {
            setFormData({
                name: clientData.name || '',
                address: clientData.address || '',
                phone: clientData.phone || '',
                notes: clientData.notes || '',
                sellerId: clientData.sellerId || '',
                sellerName: clientData.sellerName || '',
                contacts: clientData.contacts && clientData.contacts.length > 0 ? clientData.contacts : [{ name: '', email: '', phone: '', isPrimary: true }]
            });
        }
    }, [clientData, isEditMode]);

    const handleMainChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSellerChange = (e) => {
        const sellerId = e.target.value;
        const seller = sellers.find(s => s.id === sellerId);
        setFormData(prev => ({
            ...prev,
            sellerId: sellerId,
            sellerName: seller ? (seller.name || seller.email) : ''
        }));
    };

    const handleContactChange = (index, field, value) => {
        const updatedContacts = [...formData.contacts];
        updatedContacts[index][field] = value;
        setFormData(prev => ({ ...prev, contacts: updatedContacts }));
    };

    const addContact = () => {
        setFormData(prev => ({
            ...prev,
            contacts: [...prev.contacts, { name: '', email: '', phone: '', isPrimary: false }]
        }));
    };

    const removeContact = (index) => {
        const updatedContacts = formData.contacts.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, contacts: updatedContacts }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl">
                <h2 className="text-2xl font-bold mb-4">{isEditMode ? 'Editar Cliente' : 'Nuevo Cliente'}</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input type="text" placeholder="Nombre de la Empresa *" value={formData.name} onChange={(e) => handleMainChange('name', e.target.value)} className="w-full p-2 border rounded-md" required/>
                        <input type="tel" placeholder="Teléfono Principal" value={formData.phone} onChange={(e) => handleMainChange('phone', e.target.value)} className="w-full p-2 border rounded-md" />
                        <input type="text" placeholder="Dirección" value={formData.address} onChange={(e) => handleMainChange('address', e.target.value)} className="w-full p-2 border rounded-md md:col-span-2" />
                        <textarea placeholder="Notas generales..." value={formData.notes} onChange={(e) => handleMainChange('notes', e.target.value)} className="w-full p-2 border rounded-md md:col-span-2" rows="2"></textarea>
                        
                        <div>
                            <label className="text-sm font-medium text-gray-700">Vendedor Asignado</label>
                            <select value={formData.sellerId} onChange={handleSellerChange} className="w-full p-2 border bg-white rounded-md">
                                <option value="">Sin Asignar</option>
                                {sellers.map(seller => (
                                    <option key={seller.id} value={seller.id}>{seller.name || seller.email}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <h3 className="text-lg font-semibold pt-2 border-t mt-4">Contactos</h3>
                    {formData.contacts.map((contact, index) => (
                        <div key={index} className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                            <input type="text" placeholder="Nombre Contacto *" value={contact.name} onChange={(e) => handleContactChange(index, 'name', e.target.value)} className="w-full p-2 border rounded-md" required/>
                            <input type="email" placeholder="Email" value={contact.email} onChange={(e) => handleContactChange(index, 'email', e.target.value)} className="w-full p-2 border rounded-md" />
                            <input type="tel" placeholder="Teléfono" value={contact.phone} onChange={(e) => handleContactChange(index, 'phone', e.target.value)} className="w-full p-2 border rounded-md" />
                            {formData.contacts.length > 1 && <button type="button" onClick={() => removeContact(index)} className="text-red-500 hover:text-red-700 text-sm">Eliminar</button>}
                        </div>
                    ))}
                     <button type="button" onClick={addContact} className="text-sm text-blue-600 hover:underline">+ Añadir otro contacto</button>

                    <div className="flex justify-end gap-4 mt-6">
                        <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium bg-gray-200 rounded-md hover:bg-gray-300">Cancelar</button>
                        <button type="submit" className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">Guardar Cliente</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ClientEditModal;

